document.addEventListener('DOMContentLoaded', function() {
    const featureProductSlider = document.querySelector('.featured-products-slider');
    let slideStep = featureProductSlider.dataset.sliderNumbers || 1;
    if (window.innerWidth <= 480 && featureProductSlider.dataset.sliderNumbers > 3) {
      slideStep = 3;
    } else if (window.innerWidth <= 768 && featureProductSlider.dataset.sliderNumbers > 4) {
      slideStep = 4;
    }else if(window.innerWidth < 1200 && featureProductSlider.dataset.sliderNumbers > 6){
      slideStep = 6;
    }else if(window.innerWidth >= 1200 && featureProductSlider.dataset.sliderNumbers > 8){
      slideStep = 8;
    }
    class HorizontalSlider {
      constructor(options) {
        // 默认配置
        const defaults = {
          containerSelector: '.featured-products-slider .slider-container',
          viewportSelector: '.featured-products-slider .slider-viewport',
          trackSelector: '.featured-products-slider .slider-track',
          itemsSelector: '.featured-products-slider .slider-item',
          prevButtonSelector: '.featured-products-slider .prev-button',
          nextButtonSelector: '.featured-products-slider .next-button',
          progressBarSelector: '.featured-products-slider .progress-bar',
          counterSelector: '.featured-products-slider .page-counter',
          visibleBigSizeCount: 8,    //超过1200px可见项目数
          visibleCount: 6,          // PC端可见项目数
          mobileVisibleCount: 4,    // 平板端可见项目数
          smallMobileVisibleCount: 3, // 手机端可见项目数
          slideStep: slideStep,             // 每次滑动项目数
          enableTouch: true,        // 启用触摸滑动
          touchThreshold: 50,       // 滑动阈值(px)
          progressWidth: '160px',   // 进度条宽度
          enableMouseDrag: true, 
          ...options
        };
        this.lastMouseDownTime = Date.now();
        // 合并配置
        this.config = defaults;
        
        // 初始化元素
        this.initElements();
        
        // 检查必要元素
        if (!this.track || this.items.length === 0) {
         
          return;
        }
        
        // 设置CSS变量
        this.setCSSVariables();
        
        // 初始化滑动组件
        this.initSlider();
        
        // 设置事件监听
        this.setupEventListeners();
        
        // 初始更新UI
        this.updateUI();
      }
      
    initElements() {
        // 获取DOM元素
        this.container = document.querySelector(this.config.containerSelector);
        this.viewport = document.querySelector(this.config.viewportSelector);
        this.track = document.querySelector(this.config.trackSelector);
        this.items = Array.from(document.querySelectorAll(this.config.itemsSelector));
        this.prevButton = document.querySelector(this.config.prevButtonSelector);
        this.nextButton = document.querySelector(this.config.nextButtonSelector);
        this.progressBar = document.querySelector(this.config.progressBarSelector);
        this.counter = document.querySelector(this.config.counterSelector);
        
        // 触摸相关变量
        this.touchStartX = 0;
        this.touchEndX = 0;
        this.isDragging = false;
        this.mouseStartX = 0; // 新增：鼠标起始位置
        this.mouseIsDown = false; // 新增：鼠标按下状态
        this.currentTranslate = 0; // 新增：当前位移值
      }
      
      setCSSVariables() {
          if (this.container) {
            const visibleCount = this.getCurrentVisibleCount();
            const containerWidth = this.container.offsetWidth;
            const gap = (containerWidth * 0.02); // 间距为父级宽度的2%
            
            this.container.style.setProperty('--visible-count', visibleCount);
            this.container.style.setProperty('--gap', `${gap}px`);
            
            // 计算并设置居中所需的偏移量
            const totalItems = this.items.length;
            this.shouldCenterItems = totalItems <= visibleCount;
            
            if (this.shouldCenterItems) {
                const remainingSpace = 100 - (100 / visibleCount * totalItems);
                this.track.style.justifyContent = 'center';
                this.container.style.setProperty('--visible-count', totalItems);
                
            } else {
                this.track.style.justifyContent = 'flex-start';
                this.track.style.marginLeft = '0';
            }
        }
        
        if (this.progressBar && this.progressBar.parentElement) {
            this.progressBar.parentElement.style.width = this.config.progressWidth;
        }
      }
      checkProgressVisibility() {
        // 根据屏幕宽度和项目数量决定是否显示进度条
        const screenWidth = window.innerWidth;
        const totalItems = this.items.length;
        if(screenWidth > 1200){
          this.shouldShowProgress = totalItems > 8;

        }
        else if (screenWidth > 768) { // PC端
            this.shouldShowProgress = totalItems > 6;
        } else if (screenWidth > 480) { // 平板端
            this.shouldShowProgress = totalItems > 4;
        } else { // 移动端
            this.shouldShowProgress = totalItems > 3;
        }
        
        // 应用显示/隐藏状态
        if (this.progressBar && this.progressBar.parentElement) {
            this.progressBar.parentElement.style.display = this.shouldShowProgress ? 'block' : 'none';
        }
    }

    initSlider() {
        // 计算总页数
        const visibleCount = this.getCurrentVisibleCount();
        this.totalPages = Math.ceil(
          (this.items.length - visibleCount) / this.config.slideStep
        ) + 1;
        // 检查是否需要显示进度条
        this.checkProgressVisibility();
        // 初始化状态
        this.currentPage = 0;
      }
      
      getCurrentVisibleCount() {
        // 根据屏幕宽度返回当前可见项目数
        if (window.innerWidth <= 480) {
          return this.config.smallMobileVisibleCount;
        } else if (window.innerWidth <= 768) {
          return this.config.mobileVisibleCount;
        }else if(window.innerWidth < 1200){
          return this.config.visibleCount;
        }
        return this.config.visibleBigSizeCount;
      }
      
      setupEventListeners() {
        // 按钮事件
        if (this.prevButton) {
          this.prevButton.addEventListener('click', () => this.slideTo(this.currentPage - 1));
        }
        
        if (this.nextButton) {
          this.nextButton.addEventListener('click', () => this.slideTo(this.currentPage + 1));
        }
        
        // 触摸事件
        if (this.config.enableTouch && this.viewport) {
          this.viewport.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: true });
          this.viewport.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: false });
          this.viewport.addEventListener('touchend', this.handleTouchEnd.bind(this), { passive: true });
        }
        // 新增：鼠标拖拽事件（仅PC端）
        if (this.config.enableMouseDrag && this.viewport && window.innerWidth > 768) {
          this.viewport.addEventListener('mousedown', this.handleMouseDown.bind(this));
          document.addEventListener('mousemove', this.handleMouseMove.bind(this));
          document.addEventListener('mouseup', this.handleMouseUp.bind(this));
          this.viewport.style.cursor = 'grab'; // 设置鼠标样式
        }
        
        // 窗口大小变化事件
        window.addEventListener('resize', this.handleResize.bind(this));
      }
       // 处理鼠标按下事件
       handleMouseDown(e) {
        this.lastMouseDownTime = Date.now();
        if (e.target.tagName !== 'A') {
          e.preventDefault();
          this.mouseIsDown = true;
          this.mouseStartX = e.clientX;
          this.viewport.style.cursor = 'grabbing';
          
          // 临时禁用track内所有链接的点击
          this.links = this.track.querySelectorAll('a');
          this.links.forEach(link => {
            link.addEventListener('click', this.preventClick, true);
          });
        }
      }

      // 新增：处理鼠标移动事件
      handleMouseMove(e) {
        if (!this.mouseIsDown) return;
        e.preventDefault();
        
        const mouseCurrentX = e.clientX;
        const diffX = mouseCurrentX - this.mouseStartX;
        
        // 计算位移百分比
        const visibleCount = this.getCurrentVisibleCount();
        const maxTranslate = (this.items.length - visibleCount) * (100 / this.items.length) * (this.items.length / visibleCount);
        
        // 限制边界
        let newTranslate = this.currentTranslate + (diffX / this.viewport.offsetWidth * 100);
        newTranslate = Math.min(0, Math.max(-maxTranslate, newTranslate));
        
        // 应用实时拖拽效果
        this.track.style.transform = `translateX(${newTranslate}%)`;
      }
      // 新增：处理鼠标释放事件
      handleMouseUp(e) {
        if (!this.mouseIsDown) return;
        // 计算鼠标按下到释放的时间
        const clickDuration = Date.now() - this.lastMouseDownTime;
        // 恢复所有链接的点击
        if (this.links) {
          this.links.forEach(link => {
            link.removeEventListener('click', this.preventClick, true);
          });
          this.links = null;
        }
        const mouseEndX = e.clientX;
        const diffX = mouseEndX - this.mouseStartX;
        // 如果是快速点击(小于300ms)且移动距离小，则阻止点击
        if (clickDuration < 200) {
          e.preventDefault();
          e.stopPropagation();
        }
        // 只有拖拽距离超过阈值才阻止默认行为
        if (Math.abs(diffX) > this.config.touchThreshold) {
          // 处理拖拽逻辑...
          if (diffX > 0) {
            this.slideTo(this.currentPage - 1);
          } else {
            this.slideTo(this.currentPage + 1);
          }
        }
        
        this.mouseIsDown = false;
        this.viewport.style.cursor = 'grab';
      }
      handleTouchStart(e) {
        this.touchStartX = e.touches[0].clientX;
        this.isDragging = true;
      }
      
      handleTouchMove(e) {
        if (!this.isDragging) return;
        
        this.touchEndX = e.touches[0].clientX;
        const diff = this.touchStartX - this.touchEndX;
        
        // 如果主要是水平滑动，阻止垂直滚动
        if (Math.abs(diff) > 5) {
          e.preventDefault();
        }
      }
      
      handleTouchEnd() {
        if (!this.isDragging) return;
        
        const diff = this.touchStartX - this.touchEndX;
        
        if (Math.abs(diff) > this.config.touchThreshold) {
          if (diff > 0) {
            this.slideTo(this.currentPage + 1); // 向左滑动
          } else {
            this.slideTo(this.currentPage - 1); // 向右滑动
          }
        }
        
        this.isDragging = false;
        this.touchStartX = 0;
        this.touchEndX = 0;
      }
      
      handleResize() {
        // 重新计算总页数
        this.initSlider();
        // 确保当前页在有效范围内
        this.slideTo(Math.min(this.currentPage, this.totalPages - 1));
      }
      
      slideTo(page) {
        // 边界检查
        page = Math.max(0, Math.min(page, this.totalPages - 1));
        
        // 计算需要移动的项目数
        const moveCount = page * this.config.slideStep;
        
        // 计算位移百分比
        const visibleCount = this.getCurrentVisibleCount();
        this.currentTranslate = -(moveCount * (100 / this.items.length)) * (this.items.length / visibleCount);
        
        // 应用滑动
        this.currentPage = page;
        this.track.style.transform = `translateX(${this.currentTranslate}%)`;
        
        // 更新UI状态
        this.updateUI();
      }
      
      updateUI() {

        // 更新按钮状态
        if (this.prevButton) {
          this.prevButton.style.visibility = this.currentPage === 0 ? 'none' : '';
          this.currentPage === 0 ? this.prevButton.classList.remove('is-show') : this.prevButton.classList.add('is-show');
        }
        
        if (this.nextButton) {
          this.nextButton.style.visibility = this.currentPage === this.totalPages - 1 ? 'none' : '';
          this.currentPage === this.totalPages - 1 ? this.nextButton.classList.remove('is-show') : this.nextButton.classList.add('is-show');
        }
        if(this.shouldCenterItems){
          this.nextButton.classList.remove('is-show');
          this.prevButton.classList.remove('is-show');
        }
        // 更新进度条
        if (this.progressBar) {
          const progress = ((this.currentPage + 1) / this.totalPages) * 100;
          this.progressBar.style.width = `${progress}%`;
        }
        
        // 更新页码计数器
        if (this.counter) {
          this.counter.textContent = `${this.currentPage + 1}/${this.totalPages}`;
        }
      }
    }
  
    // 初始化滑动组件
    const slider = new HorizontalSlider({
      visibleBigSizeCount:8,    //超过1200px显示8个
      visibleCount: 6,          // PC端显示6个
      mobileVisibleCount: 4,    // 平板显示3个
      smallMobileVisibleCount: 3, // 手机显示2个
      slideStep: slideStep,             // 每次滑动3个
      progressWidth: '160px',   // 进度条宽度
      touchThreshold: 50 ,       // 滑动灵敏度
      enableMouseDrag: true // 启用鼠标拖拽
    });
});